<div class="main-table">
  <div class="main-table-companies" *ngIf="!showEndpoint">
    <ng-container *ngIf="dataCompanies.length > 0; else noDataTable">
      <nz-table
        [nzScroll]="{ y: tableHeight }"
        [nzSize]="'small'"
        [nzFrontPagination]="false"
        (nzPageIndexChange)="onPageIndexChange($event, 'companies')"
        [nzPageSize]="paginationState.per_page"
        [nzPageIndex]="paginationState.current_page"
        [nzTotal]="paginationState.total"
        [nzData]="dataCompanies"
        #wrapper
      >
        <thead>
          <tr>
            <th nzWidth="40px"></th>
            <th nzWidth="90px">OFF/ON</th>
            <th nzWidth="90px">ID</th>
            <th nzWidth="230px" (click)="sort('name')">
              NAME
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'name'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'name'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th nzWidth="90px" *ngIf="isOptionActive('type', type)">TYPE</th>
            <th nzWidth="200px" *ngIf="isOptionActive('formats', type)">
              AD FORMATS
            </th>
            <th
              nzWidth="180px"
              *ngIf="isOptionActive('incoming_qps', type)"
              (click)="sort('incoming_qps')"
            >
              Incoming QPS
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'incoming_qps'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'incoming_qps'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="110px"
              *ngIf="isOptionActive('qps', type)"
              (click)="sort('qps')"
            >
              Valid QPS
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'qps'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'qps'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="140px"
              *ngIf="isOptionActive('bidqps', type)"
              (click)="sort('bidqps')"
            >
              BID QPS
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'bidqps'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'bidqps'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="180px"
              *ngIf="isOptionActive('daylySpend', type)"
              (click)="sort('daylySpend')"
            >
              DAILY SPEND
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'daylySpend'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'daylySpend'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="180px"
              *ngIf="isOptionActive('yesterdaySpend', type)"
              (click)="sort('yesterdaySpend')"
            >
              YESTERDAY SPEND
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'yesterdaySpend'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'yesterdaySpend'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="180px"
              *ngIf="isOptionActive('ssp_ecpm', type)"
              (click)="sort('ssp_ecpm')"
            >
              Daily CPM
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'ssp_ecpm'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'ssp_ecpm'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="180px"
              *ngIf="isOptionActive('ssp_rcpm', type)"
              (click)="sort('ssp_rcpm')"
            >
              SSP RCPM
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'ssp_rcpm'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'ssp_rcpm'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="200px"
              *ngIf="isOptionActive('valid_bid_rate', type)"
              (click)="sort('valid_bid_rate')"
            >
              VALID BID RATE, %
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'valid_bid_rate'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'valid_bid_rate'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="150px"
              *ngIf="isOptionActive('win_rate', type)"
              (click)="sort('win_rate')"
            >
              WIN RATE, %
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'win_rate'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'win_rate'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="170px"
              *ngIf="isOptionActive('render_rate', type)"
              (click)="sort('render_rate')"
            >
              RENDER RATE, %
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'render_rate'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'render_rate'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="130px"
              *ngIf="isOptionActive('fill_rate', type)"
              (click)="sort('fill_rate')"
            >
              FILL RATE %
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'fill_rate'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'fill_rate'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th nzWidth="170px" *ngIf="isOptionActive('spendLimit', type)">
              SPEND LIMIT
            </th>
            <th
              nzWidth="130px"
              *ngIf="isOptionActive('margin', type)"
              (click)="sort('margin')"
            >
              MARGIN
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'margin'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'margin'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th nzWidth="130px" *ngIf="isOptionActive('region', type)">
              REGION
            </th>
            <th nzWidth="130px" *ngIf="isOptionActive('email', type)">EMAIL</th>
            <th nzWidth="115px" *ngIf="isOptionActive('comments', type)">
              COMMENTS
            </th>
          </tr>
        </thead>
        <tbody style="min-width: 1360px">
          <ng-container *ngFor="let company of dataCompanies; let k = index">
            <tr>
              <td class="td-toggle" (click)="toggleCompanyState(company.id)">
                <div class="arrow" [@toggleArrow]="isClosed(company.id)">
                  <i
                    nz-icon
                    nzType="right"
                    nzTheme="outline"
                    style="color: #002199; font-size: 16px"
                  ></i>
                </div>
              </td>
              <td>
                <nz-switch
                  [nzControl]="true"
                  (click)="
                    onChangeActiveCompany($event, company.id, 'ssp', company)
                  "
                  [(ngModel)]="company.active"
                  [nzDisabled]="userRole === 'viewer'"
                ></nz-switch>
              </td>
              <td></td>
              <td>
                <span
                  nz-tooltip
                  nzTooltipTitle="{{ company.name }}"
                  nzTooltipPlacement="top"
                  >{{ company.name | trunc: [20] }}
                </span>
              </td>
              <td *ngIf="isOptionActive('type', type)">-</td>
              <td *ngIf="isOptionActive('formats', type)"></td>
              <td *ngIf="isOptionActive('incoming_qps', type)">
                {{ company.incoming_qps }}
              </td>
              <td *ngIf="isOptionActive('qps', type)">{{ company.qps }}</td>
              <td *ngIf="isOptionActive('bidqps', type)">
                {{ company.bidqps }}
              </td>
              <td *ngIf="isOptionActive('daylySpend', type)">
                {{
                  currencyPipe.transform(
                    +company.daylySpend,
                    "USD",
                    "symbol",
                    ".0-5"
                  )
                }}
              </td>
              <td *ngIf="isOptionActive('yesterdaySpend', type)">
                {{
                  currencyPipe.transform(
                    +company.yesterdaySpend,
                    "USD",
                    "symbol",
                    ".0-5"
                  )
                }}
              </td>
              <td *ngIf="isOptionActive('ssp_ecpm', type)">
                {{ company.ssp_ecpm }}
              </td>
              <td *ngIf="isOptionActive('ssp_rcpm', type)">
                {{ company.ssp_rcpm }}
              </td>
              <td *ngIf="isOptionActive('valid_bid_rate', type)">
                {{ company.valid_bid_rate }}
              </td>
              <td *ngIf="isOptionActive('win_rate', type)">
                {{ company.win_rate }}
              </td>
              <td *ngIf="isOptionActive('render_rate', type)">
                {{ company.render_rate }}
              </td>
              <td *ngIf="isOptionActive('fill_rate', type)">
                {{ company.fill_rate }}
              </td>
              <td *ngIf="isOptionActive('spendLimit', type)">
                {{ company.spendLimit }}
              </td>
              <td *ngIf="isOptionActive('margin', type)"></td>
              <td *ngIf="isOptionActive('region', type)">-</td>
              <td *ngIf="isOptionActive('email', type)"></td>
              <td *ngIf="isOptionActive('comments', type)"></td>
            </tr>
            <tr>
              <td
                class="td-expand"
                *ngIf="isClosed(company.id) === 'visible'"
                [colSpan]="colSpanNumbers"
                style="padding: 0 !important"
              >
                <app-list-endpoints
                  [supply]="supply"
                  [endpoints]="company.ssp_settings"
                  [isClosed]="companiesState[company.id]"
                  [userRole]="userRole"
                  [side]="'ssp'"
                  [companyId]="company.id"
                  [allCompanies]="allCompanies"
                  [partnerSettings]="partnerSettings"
                  [filterLists]="filterLists"
                  (updateSSP)="onUpdateSSP($event)"
                  (duplicatedEndpoint)="duplicateListEndpoint($event)"
                  (deleteEndpoint)="deleteListEndpoint($event)"
                  (updateEndpointActiveStatus)="
                    onEndpointActiveStatusChange($event)
                  "
                ></app-list-endpoints>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </nz-table>
    </ng-container>
    <ng-template #noDataTable>
      <app-placeholder
        text="No Data Available"
        *ngIf="!sspSpinnerStatus"
        [marginTop]="placeholderMarginTop"
      ></app-placeholder>
    </ng-template>
  </div>
  <div class="main-table-endpoints" *ngIf="showEndpoint">
    <ng-container *ngIf="dataEndpoints.length > 0; else noDataTable">
      <nz-table
        [nzScroll]="{ y: tableHeight }"
        [nzSize]="'small'"
        [nzFrontPagination]="false"
        (nzPageIndexChange)="onPageIndexChange($event, 'endpoints')"
        [nzPageSize]="paginationState.per_page"
        [nzPageIndex]="paginationState.current_page"
        [nzTotal]="paginationState.total"
        [nzData]="dataEndpoints"
        #wrapper
      >
        <thead>
          <tr>
            <th nzWidth="90px">OFF/ON</th>
            <th nzWidth="90px" (click)="sort('id')">
              ID
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'id'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'id'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th nzWidth="230px" (click)="sort('name')">
              NAME
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'name'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'name'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th nzWidth="90px" *ngIf="isOptionActive('type', type)">TYPE</th>
            <th nzWidth="200px" *ngIf="isOptionActive('formats', type)">
              AD FORMATS
            </th>
            <th
              nzWidth="180px"
              *ngIf="isOptionActive('incoming_qps', type)"
              (click)="sort('incoming_qps')"
            >
              Incoming QPS
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'incoming_qps'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'incoming_qps'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="110px"
              *ngIf="isOptionActive('qps', type)"
              (click)="sort('qps')"
            >
              Valid QPS
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'qps'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'qps'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="110px"
              *ngIf="isOptionActive('bidqps', type)"
              (click)="sort('bidqps')"
            >
              BID QPS
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'bidqps'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'bidqps'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="140px"
              *ngIf="isOptionActive('daylySpend', type)"
              (click)="sort('daylySpend')"
            >
              DAILY SPEND
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'daylySpend'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'daylySpend'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="180px"
              *ngIf="isOptionActive('yesterdaySpend', type)"
              (click)="sort('yesterdaySpend')"
            >
              YESTERDAY SPEND
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'yesterdaySpend'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'yesterdaySpend'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="180px"
              *ngIf="isOptionActive('ssp_ecpm', type)"
              (click)="sort('ssp_ecpm')"
            >
              Daily CPM
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'ssp_ecpm'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'ssp_ecpm'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="180px"
              *ngIf="isOptionActive('ssp_rcpm', type)"
              (click)="sort('ssp_rcpm')"
            >
              SSP RCPM
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'ssp_rcpm'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'ssp_rcpm'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="170px"
              *ngIf="isOptionActive('valid_bid_rate', type)"
              (click)="sort('valid_bid_rate')"
            >
              VALID BID RATE
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'valid_bid_rate'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'valid_bid_rate'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="115px"
              *ngIf="isOptionActive('win_rate', type)"
              (click)="sort('win_rate')"
            >
              WIN RATE
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'win_rate'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'win_rate'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="170px"
              *ngIf="isOptionActive('render_rate', type)"
              (click)="sort('render_rate')"
            >
              RENDER RATE
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'render_rate'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'render_rate'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th
              nzWidth="110px"
              *ngIf="isOptionActive('fill_rate', type)"
              (click)="sort('fill_rate')"
            >
              FILL RATE
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'fill_rate'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'fill_rate'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th nzWidth="170px" *ngIf="isOptionActive('spendLimit', type)">
              SPEND LIMIT
            </th>
            <th
              nzWidth="130px"
              *ngIf="isOptionActive('margin', type)"
              (click)="sort('margin')"
            >
              MARGIN
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP === 'margin'"
              >
                <span
                  class="sort-icon sort-icon-{{
                    mainTableService.sortOrderSSP
                  }}"
                ></span>
              </span>
              <span
                class="sorting-indicator"
                *ngIf="mainTableService.sortBySSP !== 'margin'"
              >
                <span class="sort-icon sort-icon-normal"></span>
              </span>
            </th>
            <th nzWidth="110px" *ngIf="isOptionActive('region', type)">
              REGION
            </th>
            <th nzWidth="130px" *ngIf="isOptionActive('email', type)">EMAIL</th>
            <th nzWidth="115px" *ngIf="isOptionActive('comments', type)">
              COMMENTS
            </th>
          </tr>
        </thead>
        <tbody style="min-width: 1360px">
          <tr
            *ngFor="let child of dataEndpoints; let j = index"
            [ngClass]="{ 'is-test': child.isForTest === 1 }"
          >
            <td>
              <nz-switch
                [(ngModel)]="child.active"
                (ngModelChange)="
                  onEndpointTableActiveStatusChange($event, child.id, type)
                "
                [nzDisabled]="isDisabledSwitch(child)"
              ></nz-switch>
            </td>
            <td>{{ child.id }}</td>
            <td class="name">
              <button
                nz-button
                nzType="text"
                [disabled]="!filterLists.length"
                nz-tooltip
                nzTooltipTitle="{{ child.name }}"
                nzTooltipPlacement="top"
                class="end-name"
                (click)="openSspEditModal(child.id, child.companyId)"
                [name]="child.name"
              >
                {{ child.name | trunc: [20] }}
              </button>
            </td>
            <td *ngIf="isOptionActive('type', type)">
              {{ connectionTypes[child.connectionType] }}
            </td>
            <td *ngIf="isOptionActive('formats', type)">
              <img
                class="icon--formats"
                *ngIf="child.formats.banner"
                [src]="'/assets/img/formats/banner.svg'"
                alt=""
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                nzTooltipTitle="Banner"
                nzTooltipPlacement="top"
              />
              <img
                class="icon--formats"
                *ngIf="child.formats.native"
                [src]="'/assets/img/formats/native.svg'"
                alt=""
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                nzTooltipTitle="Native"
                nzTooltipPlacement="top"
              />
              <img
                class="icon--formats"
                *ngIf="child.formats.video"
                [src]="'/assets/img/formats/video.svg'"
                alt=""
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                nzTooltipTitle="Video"
                nzTooltipPlacement="top"
              />
              <img
                class="icon--formats"
                *ngIf="child.formats.pop"
                [src]="'/assets/img/formats/pop.svg'"
                alt=""
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                nzTooltipTitle="Pop"
                nzTooltipPlacement="top"
              />
              <img
                class="icon--formats"
                *ngIf="child.formats.push"
                [src]="'/assets/img/formats/push.svg'"
                alt=""
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                nzTooltipTitle="Push"
                nzTooltipPlacement="top"
              />
              <img
                class="icon--formats"
                *ngIf="child.formats.audio"
                [src]="'/assets/img/formats/audio.svg'"
                alt=""
                nz-tooltip
                nzTooltipOverlayClassName="item-tooltip"
                nzTooltipTitle="Audio"
                nzTooltipPlacement="top"
              />
            </td>
            <td *ngIf="isOptionActive('incoming_qps', type)">
              {{ child.incoming_qps }}
            </td>
            <td *ngIf="isOptionActive('qps', type)">{{ child.qps }}</td>
            <td *ngIf="isOptionActive('bidqps', type)">{{ child.bidqps }}</td>
            <td *ngIf="isOptionActive('daylySpend', type)">
              {{
                currencyPipe.transform(
                  child.daylySpend,
                  "USD",
                  "symbol",
                  ".0-5"
                )
              }}
            </td>
            <td *ngIf="isOptionActive('yesterdaySpend', type)">
              {{
                currencyPipe.transform(
                  child.yesterdaySpend,
                  "USD",
                  "symbol",
                  ".0-5"
                )
              }}
            </td>
            <td *ngIf="isOptionActive('ssp_ecpm', type)">
              {{ child.ssp_ecpm }}
            </td>
            <td *ngIf="isOptionActive('ssp_rcpm', type)">
              {{ child.ssp_rcpm }}
            </td>
            <td *ngIf="isOptionActive('valid_bid_rate', type)">
              {{ child.valid_bid_rate }}
            </td>
            <td *ngIf="isOptionActive('win_rate', type)">
              {{ child.win_rate }}
            </td>
            <td *ngIf="isOptionActive('render_rate', type)">
              {{ child.render_rate }}
            </td>
            <td *ngIf="isOptionActive('fill_rate', type)">
              {{ child.fill_rate }}
            </td>
            <td *ngIf="isOptionActive('spendLimit', type)">
              {{ child.spendLimit }}
            </td>
            <td *ngIf="isOptionActive('margin', type)">
              {{ getMargin(child) }}
            </td>
            <td *ngIf="isOptionActive('region', type)">{{ child.region }}</td>
            <td
              *ngIf="isOptionActive('email', type)"
              nz-tooltip
              nzTooltipOverlayClassName="item-tooltip"
              [nzTooltipTitle]="child.email"
              nzTooltipPlacement="top"
            >
              {{ child.email | trunc: [10] }}
            </td>
            <td
              *ngIf="isOptionActive('comments', type)"
              nz-tooltip
              nzTooltipOverlayClassName="item-tooltip"
              [nzTooltipTitle]="child.comments"
              nzTooltipPlacement="top"
            >
              {{ child.comments | trunc: [10] }}
            </td>
          </tr>
        </tbody>
      </nz-table>
    </ng-container>
    <ng-template #noDataTable>
      <app-placeholder
        text="No Data Available"
        [marginTop]="placeholderMarginTop"
        *ngIf="!sspSpinnerStatus"
      ></app-placeholder>
    </ng-template>
  </div>
</div>
